import React from 'react';
import './ChatMessageBubble.css';

export default function ChatMessageBubble({ message, timestamp, isOwn }) {
  const parsed = timestamp ? new Date(timestamp) : null;
  const time = parsed && !Number.isNaN(parsed.getTime())
    ? parsed.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    : '';

  return (
    <div className={`chat-bubble ${isOwn ? 'chat-bubble--own' : 'chat-bubble--other'}`}>
      <div className="chat-bubble__text">{message}</div>
      {time && <div className="chat-bubble__time">{time}</div>}
    </div>
  );
}
